"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const Table = (0, react_1.forwardRef)(({ border = true, children, className, compact, scrollable, stacked, stackedHeader, striped, ...props }, ref) => {
    const table = ((0, jsx_runtime_1.jsx)("table", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-table', !border && 'usa-table--borderless', compact && 'usa-table--compact', stacked && 'usa-table--stacked', stackedHeader && 'usa-table--stacked-header', striped && 'usa-table--striped', className), ...props, children: children }));
    return scrollable ? ((0, jsx_runtime_1.jsx)("div", { className: "usa-table-container--scrollable", children: table })) : (table);
});
exports.default = Table;
